export enum AnswerType {
    Boolean = "boolean",
    Integer = "integer",
    SingleItem = "singleItem",
    MultipleItems = "multipleItems",
}

